module.exports = __webpack_public_path__ + "static/media/view5-ex1-slow.1f32d072.mp3";